import { useAppSelector } from 'redux/store';

export const useProfile = () => {
  return useAppSelector((state) => {
    const { users, userType } = state.usersSlice;
    if (!userType) return null;
    const user = users?.[userType];
    if (!user) return null;
    return { ...user, type: userType };
  });
};
